<template>
  <div class="pupils">

    <div v-if="hasAccess">

    <header class="px-6 mx-4">
      <div class="flex justify-between">
        <div>
        <h2 class="text-xl font-semibold w-64 inline-block">
          Timeline
      </h2>
      <div class="text-gray-500 pb-4">
        Please select a pupil to view the timeline.
      </div>
    </div>
    <div>

      <div class="flex">
        <button
                  v-for="grade in gradesList"
                  :key="grade.key"
                  type="button"
                  @click="filterTag(grade.value)"
                  class="tag-example mr-2 h-8 w-20"
                  :class="applyCss(grade)"
                >
                  #{{ parseTagGradeValue(grade.value) }}
                </button>
                

                    <input
              type="search"
              class="filter-bar-search focus:outline-none w-56 ml-4"
              name="search"
              v-model="search"
              placeholder="Search pupils..."
            />
            <i
              class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50"
              @click="search = ''"
              title="Clear search"
              v-show="search.length > 0"
            ></i>

   
         </div>

       

          </div>
          
      </div>
    </header>


     <pupilsselect @pupil-selected="selectPupil" :orderedPupils="pupils"    
      :inputSearch="search" v-if="!loading">

     </pupilsselect>

     </div>
         <div class="ml-4" v-else>
        <UpgradeContent :area="'Reporting'"></UpgradeContent>
      </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PupilService } from "@/services/pupil.service";

const pupilsselect = () => import("@/components/PupilsGridSelect.vue");
const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");
export default {
  name: "pupils",
  props: ["filterValues", "hasAccess"],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",

    }),
    gradesList() {
      let list = this.settings.assessmentGradesList.filter((c) => c.used === true)
      return list.splice(0, 3)
    },
    applyCss() {
      return (grade) => { 
        let isIncluded = this.hasFilterTag(grade.value)
        let bgOpacity = isIncluded ? 'bg-opacity-100' : 'bg-opacity-50' 
        let bgColor = isIncluded ? 'text-white border-none bg-' + grade.color : 'text-gray-700 border bg-white'
        return bgOpacity + " " + bgColor
      }
    }
  },
  data() {
    return {
      pupils: [],
      loading: true,
      errored: false,
      search: "",
      filteredTags: []
    };
  },
  created() {},
  mounted() {
    this.searchPupils()
  },
  watch: {
    '$props':{
      handler: function (val, oldVal) { 
        this.searchPupils()
      },
      deep: true
    }
  },
  methods: {
    searchPupils() {
      this.loading = true;

      PupilService.getWithFilter(this.filterValues, 1, 5000)
        .then((response) => this.pupils = response.data.data)
        .catch((err) => {
          console.log("pupils " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectPupil(pupil) {
      this.$router.push({
        name: "TimelineView",
        params: { pupil: pupil, calendar: this.filterValues.calendar},
      });
      window.scrollTo(0, 0);
    },
    parseTagGradeValue(value) {
      return value.replace(" ", "_").toLowerCase()
    },
    filterTag(value) {
      let tag = this.parseTagGradeValue(value)

      if (this.hasFilterTag(value)) {
        this.filteredTags.splice(tag)
      } else {
        this.filteredTags.push(tag)
      }

      let tags = this.filteredTags.join(",")
      this.filterValues.tags = tags

      this.searchPupils()
    },
    hasFilterTag(value) {
      return this.filteredTags.includes(this.parseTagGradeValue(value))
    },
  },
  components: {
    pupilsselect,
    UpgradeContent
  },
};
</script>
